// services/stripeService.js

export const createAccount = async (userType, userId, email, country) => {
  try {
    // Input validation
    if (!userType || !userId || !email || !country) {
      throw new Error('Missing required fields');
    }

    if (!['investor', 'borrower'].includes(userType)) {
      throw new Error('Invalid user type');
    }

    // Determine the endpoint based on user type
    const endpoint =
      userType === 'borrower' ? `/borrowers/${userId}/stripe-account` : `/investors/${userId}/stripe-account`;

    const API_URL = process.env.REACT_APP_API_URL;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    if (!API_URL || !API_TOKEN || !BASE_URL) {
      throw new Error('Missing environment variables');
    }

    // Call your backend API
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${API_TOKEN}`,
      },
      body: JSON.stringify({
        email,
        country,
        userId,
        baseUrl: `${BASE_URL}`,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create Stripe account');
    }

    // Make sure onboarding URL is present
    if (!data.onboardingUrl) {
      throw new Error('No onboarding URL returned from server');
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error creating Stripe account:', error);
    return {
      data: null,
      error: error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};
export const refreshOnboarding = async (userType, userId) => {
  try {
    // Input validation
    if (!userType || !userId) {
      throw new Error('Missing required fields');
    }

    if (!['investor', 'borrower'].includes(userType)) {
      throw new Error('Invalid user type');
    }

    const API_URL = process.env.REACT_APP_API_URL;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    if (!API_URL || !API_TOKEN || !BASE_URL) {
      throw new Error('Missing environment variables');
    }

    // Call your backend API
    const response = await fetch(`${API_URL}/stripe/refresh-onboarding`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${API_TOKEN}`,
      },
      body: JSON.stringify({
        userType,
        userId,
        baseUrl: `${BASE_URL}`,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to refresh onboarding link');
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error refreshing onboarding link:', error);
    return {
      data: null,
      error: error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};
export const getAccountStatus = async (accountId) => {
  try {
    // Input validation
    if (!accountId) {
      throw new Error('Missing account ID');
    }

    const API_URL = process.env.REACT_APP_API_URL;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    if (!API_URL || !API_TOKEN) {
      throw new Error('Missing environment variables');
    }

    // Call your backend API
    const response = await fetch(`${API_URL}/stripe/accounts/${accountId}/status`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${API_TOKEN}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to get account status');
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error fetching Stripe account status:', error);
    return {
      data: null,
      error: error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};

// Other Stripe-related functions in this service
export const StripeService = {
  createAccount,

  // handleAccountUpdate: async (userType, userId, eventData) => {
  //   // Implementation for handling webhook events or account updates
  // },
};

export default StripeService;
